import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const MEDAL = { 1: { label: 'Top ID Hunter', icon: '🥇', color: '#f7d55c' }, 2: { label: 'ID Hunter', icon: '🥈', color: '#d0d0d0' }, 3: { label: 'ID Hunter', icon: '🥉', color: '#e0a36a' } };

let cache = { at: 0, data: null, promise: null };
export const fetchIdLeaderboard = () => {
  if (cache.data && Date.now() - cache.at < 60000) return Promise.resolve(cache.data);
  if (!cache.promise) {
    cache.promise = fetch(`${API}/api/wall/id-leaderboard`).then(r => r.json())
      .then(d => { cache = { at: Date.now(), data: d, promise: null }; return d; })
      .catch(() => { cache.promise = null; return null; });
  }
  return cache.promise;
};

// Monthly Wall ID Hunter medal (top 3) — for profile pages and the DJ Booth header.
export const IdHunterMedal = ({ userId, size = 'md', showCount = true, asRow = false }) => {
  const [entry, setEntry] = useState(null);
  useEffect(() => {
    if (!userId) return undefined;
    let on = true;
    fetchIdLeaderboard().then(d => {
      if (!on || !d?.leaders) return;
      const e = d.leaders.find(l => l.user_id === userId && l.rank <= 3);
      setEntry(e ? { ...e, month: d.month } : null);
    });
    return () => { on = false; };
  }, [userId]);
  if (!entry) return null;
  const m = MEDAL[entry.rank];
  const big = size === 'lg';
  const medal = (
    <span
      data-testid={`id-hunter-medal-${userId}`}
      title={`#${entry.rank} on the Wall ID leaderboard · ${entry.month} · ${entry.ids} clip${entry.ids !== 1 ? 's' : ''} ID'd`}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
        padding: big ? '6px 14px' : '3px 10px', borderRadius: 999, fontWeight: 700,
        fontSize: big ? '0.85rem' : '0.7rem', color: m.color, background: `${m.color}14`, border: `1px solid ${m.color}66`,
        boxShadow: entry.rank === 1 ? `0 0 14px ${m.color}44` : 'none',
      }}
    >
      <span aria-hidden>{m.icon}</span>{m.label}{showCount && <span style={{ opacity: 0.7, fontWeight: 500 }}>· {entry.ids} ID{entry.ids !== 1 ? 's' : ''} this month</span>}
      {entry.streak >= 2 && (
        <span data-testid={`id-hunter-streak-${userId}`} title={`${entry.streak} months in a row in the top 3`}
          style={{ marginLeft: 4, padding: '1px 6px', borderRadius: 999, background: 'rgba(255,120,40,0.18)', border: '1px solid rgba(255,140,50,0.6)', color: '#ff9a3c', fontSize: big ? '0.75rem' : '0.65rem', fontWeight: 800 }}>
          🔥{entry.streak}
        </span>
      )}
    </span>
  );
  if (!asRow) return medal;
  return (
    <div data-testid="id-hunter-rank-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '2px 0 8px', flexWrap: 'wrap' }}>
      <span style={{ fontSize: '0.72rem', color: '#9aa4b2', letterSpacing: '0.04em' }}>Wall ID rank · #{entry.rank} in {entry.month}</span>
      {medal}
    </div>
  );
};

export default IdHunterMedal;
